import { render } from "./CustomTextArea.vue?vue&type=template&id=7a63a099&ts=true"
import script from "./CustomTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomTextArea.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Inputs/CustomTextArea/CustomTextArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a63a099"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a63a099', __exports__)) {
    api.reload('7a63a099', __exports__)
  }
  
  module.hot.accept("./CustomTextArea.vue?vue&type=template&id=7a63a099&ts=true", () => {
    api.rerender('7a63a099', render)
  })

}


export default __exports__